import * as React from "react";

const CollapseableAngleDownInactive: React.FC = () => (
    <svg
        width="18px"
        height="10px"
        viewBox="0 0 18 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="9 0 9.557 .551 17.443 8.348 18 8.899 16.886 10 16.329 9.449 9 2.203 1.671 9.449 1.114 10 0 8.899 .557 8.348 8.443 .551"
            transform="matrix(1 0 0 -1 0 10)"
        />
    </svg>
);

export default React.memo(CollapseableAngleDownInactive);
